<template>
    <alert :color="color" :icon="icon" :tile="tile" :xs-tile="xsTile" :sm-tile="smTile"
           :vertical="vertical"
           spaced
           :md-tile="mdTile" :lg-tile="lgTile" :shadow="shadow" :shadow-large="shadowLarge" :shadow-medium="shadowMedium" :shadow-small="shadowSmall || card" :no-spacing="noSpacing"
           :flat="flat"
           :content="text ?? ($slots.default ? null : $t('missing.data'))"
           :button="button" :to="to" @click="$emit('click')"
           :type="color" :button-icon="buttonIcon"
           :class="{'bg-white': card && !color}"
           :style="{minHeight: minHeightStyle}">
        <slot/>

		<template v-if="$slots.button" #button>
			<slot name="button"/>
		</template>
    </alert>
</template>

<script>
import GridElement from "../Layout/Grid/GridElement";
    import Shadowable from "../../mixins/Shadowable";
    import {formatDimension} from "@spoferan/spoferan-ts-core";

    export default {
        name: "MissingInfo",

        mixins: [GridElement, Shadowable],

		emits: ['click'],

        props: {
            icon: {
                type: [String, Boolean],
                default: null
            },
            // The HTML content to render in the alert
            text: {
                type: String,
                default: null
            },
            // The text to display on a button to navigate the user to a corresponding creation page
            // or true to display the button with a default 'add' text
            button: {
                type: [String ,  Boolean],
                default: null
            },
            // The route to navigate the user to when he clicks on the button
            to: {
                type: [String ,  Object],
                default: null
            },

            buttonIcon: {
                type: [String, Boolean],
                default: null
            },

            color: {
                default: null
            },
            // Whether to prevent any border radius
            tile: {
                type: Boolean,
                default: false
            },

            // Whether to render the element as card
            card: {
                type: Boolean,
                default: false
            },

            minHeight: {
                type: [String, Number],
                default: null
            },

            // Whether to vertically align the content even on desktop devices
            vertical: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            minHeightStyle() {
                return formatDimension(this.minHeight);
            }
        }
    }
</script>